<template>
  <div>
    <filtro-cadu v-model="valueData" @limparFiltro="limparFiltro()" @filtrar="filtrar()">
      <div slot="body" class="mx-5" style="height: 420px;">
        <v-row>
          <v-col cols="auto">
            <div class="fontColor1--text font-weight-bold">
              FILTRAR ÁREA DE AÇÃO
            </div>
          </v-col>
        </v-row>
        <ValidationObserver ref="observer">
          <v-row v-if="podeEditar">
            <v-col cols="12">
              <autocomplete-cadu
                placeholder=""
                title="Pilar"
                :items="pilares"
                itemText="label"
                itemValue="key"
                v-model="pilarSelecionadoLocal"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <validation-provider name="uf" mode="eager" rules="alpha" v-slot="{ errors }">
                <autocomplete-cadu
                  :errorMessage="errors[0]"
                  placeholder=""
                  title="UF"
                  :items="listaUF.map((el) => el.sigla)"
                  v-model="ufSelecionado"
                  @input="(input) => getMunicipios(input)"
                />
              </validation-provider>
            </v-col>
            <v-col cols="7">
              <validation-provider name="codIBGE" mode="eager" rules="numeric" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaCodigoIBGE"
                  :errorMessage="errors[0]"
                  placeholder=""
                  title="Código IBGE"
                  v-model="codIBGESelecionado"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider name="municipio" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="nomesMunicipios"
                  :errorMessage="errors[0]"
                  placeholder=""
                  title="Município"
                  v-model="municipioSelecionado"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </div>
    </filtro-cadu>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import jwtDecode from 'jwt-decode'

import Estado from '@/services/AreaAcao/Estado'
import ListaMunicipios from '@/services/Dominios/ListaMunicipios'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: false
    },
    podeEditar: {
      type: Boolean,
      default: false
    },
    pilares: {
      type: Array,
      default: () => []
    },
    pilarSelecionado: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      valueData: this.value,
      pilarSelecionadoLocal: this.pilarSelecionado,
      nomesUF: [],
      listaUF: [],
      listaCodigoIBGE: [],
      nomesMunicipios: [],
      listaMunicipios: [],
      ufSelecionado: '',
      codIBGESelecionado: '',
      municipioSelecionado: '',
      idUF: null,
      role: ''
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
    await this.getEstados()
    await this.getMunicipios(null)
  },
  methods: {
    async getEstados() {
      let estados = new Estado(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseEstados = await estados.getEstados()
        responseEstados.data.forEach((item) => {
          this.listaUF.push(item)
        })
      } catch (err) {
        this.listaUF = []
      }
    },
    async getMunicipios(codigo) {
      const estado = this.listaUF.find((estado) => estado.sigla === codigo)

      this.selectedUF = estado ? estado.id : null
      this.nomesMunicipios = []
      this.listaCodigoIBGE = []
      this.listaMunicipios = []

      let municipios = new ListaMunicipios(this.tokenBearer, this.$appConfig.config.API)

      if (this.selectedUF) {
        try {
          let responseMunicipios = await municipios.getMunicipio(this.selectedUF)
          responseMunicipios.data.forEach((item) => {
            this.nomesMunicipios.push(item.municipioEstado)
            this.listaCodigoIBGE.push(item.id)
            this.listaMunicipios.push(item)
          })
        } catch (err) {
          this.nomesMunicipios = []
          this.listaCodigoIBGE = []
          this.listaMunicipios = []
        }
      } else {
        try {
          let responseMunicipios = await municipios.getAllMunicipios()
          responseMunicipios.data.forEach((item) => {
            this.nomesMunicipios.push(item.municipioEstado)
            this.listaCodigoIBGE.push(item.id)
            this.listaMunicipios.push(item)
          })
        } catch (err) {
          this.nomesMunicipios = []
          this.listaCodigoIBGE = []
          this.listaMunicipios = []
        }
      }
    },
    limparFiltro() {
      this.ufSelecionado = ''
      this.codIBGESelecionado = ''
      this.municipioSelecionado = ''
      this.pilarSelecionadoLocal = ''
    },
    filtrar() {
      let objUF = this.listaUF.find((item) => item.sigla === this.ufSelecionado)

      let filtro = {
        uf: objUF != null ? objUF : '',
        codigo: this.codIBGESelecionado != null ? this.codIBGESelecionado : '',
        municipio: this.municipioSelecionado != null ? this.municipioSemUF : '',
        pilar: this.pilarSelecionadoLocal || ''
      }

      this.$emit('pilar-selecionado', this.pilarSelecionadoLocal)
      this.$emit('filtrar-area-acao', filtro)
      this.valueData = false
    }
  },
  watch: {
    valueData() {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    },
    value() {
      this.valueData = this.value
    },
    pilarSelecionado() {
      this.pilarSelecionadoLocal = this.pilarSelecionado
    }
  },
  computed: {
    municipioSemUF() {
      return this.municipioSelecionado.split(' - ')[0]
    }
  }
}
</script>

<style scoped></style>
